export const generateRedirectQueryStringForLogin = (pathname) => {
    const redirect = pathname && pathname.indexOf('auth/login') === -1
        ? `?redirect=${pathname}` : '';
    return redirect;
  }

export default {};